import SelectedLabel from './selected-label.component'

export default SelectedLabel
